import { Chart } from 'chart.js';
import Labels from './labels';
import { PAYMENT_MODE } from 'dashboard/services/filterTicketsToday'
import { createValueLabelsPlugin } from './valueLabelsPlugin';

const getAmountTicketByPeriod = (ctxId, state, tickets) => {
    const ctx = document.getElementById(ctxId);

    if (!ctx) {
        return
    }

    if (state.chartTicketsAmount) {
        state.chartTicketsAmount.destroy();
    }

    const labels = {
        daily: Labels(state.shiftPeriod).daily,
        monthly: Labels(state.shiftPeriod).monthly,
        quarterly: Labels(state.shiftPeriod).quarterly,
        yearly: Labels(state.shiftPeriod).yearly
    };

    const data = getData(tickets, state);

    const chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels[state.period],
            datasets: [
                {
                    label: 'Efectivo',
                    data: data[state.period].cash,
                    backgroundColor: '#A8E6A3',
                    borderWidth: 1
                },
                {
                    label: 'Tarjeta',
                    data: data[state.period].card,
                    backgroundColor: '#90CAF9',
                    borderWidth: 1
                }
            ]
        },
        options: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            scales: {
                xAxes: [{
                stacked: true
                }],
                yAxes: [{
                stacked: true,
                ticks: { beginAtZero: true }
                }]
            },
            tooltips: {
                enabled: false
            },
        },
        plugins: [createValueLabelsPlugin({
        format: (v) => `${Number(v).toFixed(2)} €`
        })]
    });

    return chart;
}

const getData = (tickets, state) => {
  // DAILY
  const dataDayCash = {};
  const dataDayCard = {};
  Labels(state.shiftPeriod).dailyIds.forEach(id => {
    dataDayCash[id] = 0;
    dataDayCard[id] = 0;
  });

  tickets
    .filter(ticket => !ticket.incorrect && ticket.paymentMode)
    .forEach(ticket => {
      const pm = Number(ticket.paymentMode);
      if (pm !== PAYMENT_MODE.CASH && pm !== PAYMENT_MODE.CARD) return;

      const date = new Date(ticket.ticketDate);
      const key = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

      if (dataDayCash[key] !== undefined) {
        if (pm === PAYMENT_MODE.CASH) dataDayCash[key] += ticket.totalPrice || 0;
        else dataDayCard[key] += ticket.totalPrice || 0;
      }
    });

  // MONTHLY
  const dataMonthCash = {};
  const dataMonthCard = {};
  Labels(state.shiftPeriod).monthlyIds.forEach(id => {
    dataMonthCash[id] = 0;
    dataMonthCard[id] = 0;
  });

  tickets
    .filter(ticket => !ticket.incorrect && ticket.paymentMode)
    .forEach(ticket => {
      const pm = Number(ticket.paymentMode);
      if (pm !== PAYMENT_MODE.CASH && pm !== PAYMENT_MODE.CARD) return;

      const date = new Date(ticket.ticketDate);
      const key = `${date.getMonth() + 1}-${date.getFullYear()}`;

      if (dataMonthCash[key] !== undefined) {
        if (pm === PAYMENT_MODE.CASH) dataMonthCash[key] += ticket.totalPrice || 0;
        else dataMonthCard[key] += ticket.totalPrice || 0;
      }
    });

  // QUARTERLY
  const dataQuarterCash = {};
  const dataQuarterCard = {};
  Labels(state.shiftPeriod).quarterlyIds.forEach(id => {
    dataQuarterCash[id] = 0;
    dataQuarterCard[id] = 0;
  });

  // YEARLY
  const dataYearCash = {};
  const dataYearCard = {};
  Labels(state.shiftPeriod).yearlyIds.forEach(id => {
    dataYearCash[id] = 0;
    dataYearCard[id] = 0;
  });

  tickets
    .filter(ticket => !ticket.incorrect && ticket.paymentMode)
    .forEach(ticket => {
      const pm = Number(ticket.paymentMode);
      if (pm !== PAYMENT_MODE.CASH && pm !== PAYMENT_MODE.CARD) return;

      const date = new Date(ticket.ticketDate);
      const q = Math.floor(date.getMonth() / 3) + 1;
      const qKey = `Q${q}-${date.getFullYear()}`;
      const yKey = String(date.getFullYear());

      if (dataQuarterCash[qKey] !== undefined) {
        if (pm === PAYMENT_MODE.CASH) dataQuarterCash[qKey] += ticket.totalPrice || 0;
        else dataQuarterCard[qKey] += ticket.totalPrice || 0;
      }

      if (dataYearCash[yKey] !== undefined) {
        if (pm === PAYMENT_MODE.CASH) dataYearCash[yKey] += ticket.totalPrice || 0;
        else dataYearCard[yKey] += ticket.totalPrice || 0;
      }
    });

  return {
    daily: { cash: Object.values(dataDayCash), card: Object.values(dataDayCard) },
    monthly: { cash: Object.values(dataMonthCash), card: Object.values(dataMonthCard) },
    quarterly: { cash: Object.values(dataQuarterCash), card: Object.values(dataQuarterCard) },
    yearly: { cash: Object.values(dataYearCash), card: Object.values(dataYearCard) },
  };
};

export default getAmountTicketByPeriod;